module.exports = __webpack_public_path__ + "img/ad_info.633dbdd1.svg";